import { INTEGRATIONS } from "@/lib/mockData";
import { PageHeader } from "@/components/PageHeader";
import { StatusBadge } from "@/components/StatusBadge";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Database, Info } from "lucide-react";
import { toast } from "sonner";
import { cn } from "@/lib/utils";

export default function Integrations() {
  return (
    <div className="animate-fade-up">
      <PageHeader eyebrow="Settings" title="Integrations"
        subtitle="Connect the external services Nirvana ContentOS relies on. Credentials are stored securely on the backend." />

      <Alert className="mb-6 border-accent/40 bg-accent-subtle" data-testid="supabase-notice">
        <Info className="h-4 w-4 text-accent" />
        <AlertTitle className="font-heading text-base">Supabase is the primary backend</AlertTitle>
        <AlertDescription className="text-sm text-muted-foreground">
          Database, authentication and storage run on Supabase. Connect it first — everything else builds on top.
        </AlertDescription>
      </Alert>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {INTEGRATIONS.map((it) => (
          <Card key={it.key} className={cn("flex flex-col p-5 shadow-soft", it.primary && "ring-1 ring-accent/40")} data-testid={`integration-${it.key}`}>
            <div className="flex items-start justify-between">
              <span className={cn("flex h-10 w-10 items-center justify-center rounded-lg", it.primary ? "bg-primary text-primary-foreground" : "bg-secondary text-primary")}>
                {it.primary ? <Database className="h-5 w-5" /> : <span className="text-sm font-semibold">{it.name[0]}</span>}
              </span>
              <StatusBadge status={it.status} />
            </div>
            <h3 className="mt-3 font-heading text-lg font-semibold text-foreground">{it.name}</h3>
            <p className="mt-1 flex-1 text-sm text-muted-foreground">{it.desc}</p>
            <Button variant={it.primary ? "default" : "outline"} className="mt-4 w-full"
              onClick={() => toast.info(`${it.name} setup`, { description: "Add credentials to connect this service." })}
              data-testid={`connect-${it.key}`}>
              {it.primary ? "Connect Supabase" : "Connect"}
            </Button>
          </Card>
        ))}
      </div>
    </div>
  );
}
